/** Camera-relative walk vector. +wishZ is W (look forward), +wishX is D (look right). */
export function wishVelocity(
  yaw: number,
  wishX: number,
  wishZ: number,
  speed: number,
): { x: number; z: number } {
  if (wishX === 0 && wishZ === 0) return { x: 0, z: 0 };
  const len = Math.hypot(wishX, wishZ) || 1;
  const ix = wishX / len;
  const iz = wishZ / len;
  const fx = -Math.sin(yaw);
  const fz = -Math.cos(yaw);
  const rx = Math.cos(yaw);
  const rz = -Math.sin(yaw);
  return {
    x: (rx * ix + fx * iz) * speed,
    z: (rz * ix + fz * iz) * speed,
  };
}
